import apiClient from "../../utils/interceptor";
import {
  ApiResponse,
  ServiceUserData,
  CreateServiceUserParams,
  CreateServiceUserResponse,
  UpdateServiceUserParams,
  UpdateServiceUserStatusParams,
} from "./interface";
import { API_URLS } from "../../constants";

// Helper function to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Function to get all service users
export const getAllServiceUsers = async (): Promise<
  ApiResponse<ServiceUserData[]>
> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<ServiceUserData[]>>(
      API_URLS.SERVICE_USER.GET_ALL_SERVICE_USERS,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching service users:", error);
    throw error;
  }
};

// Function to create a service user
export const createServiceUser = async (
  userParams: CreateServiceUserParams
): Promise<ApiResponse<CreateServiceUserResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<
      ApiResponse<CreateServiceUserResponse>
    >(API_URLS.SERVICE_USER.CREATE_SERVICE_USER, userParams, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating service user:", error);
    throw error;
  }
};

// Function to update a service user
export const updateServiceUser = async (
  userData: UpdateServiceUserParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<null>>(
      API_URLS.SERVICE_USER.UPDATE_SERVICE_USER,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating service user:", error);
    throw error;
  }
};

export const updateServiceUserStatus = async (
  params: UpdateServiceUserStatusParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<null>>(
      API_URLS.SERVICE_USER.UPDATE_SERVICE_USER_STATUS,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating service user status:", error);
    throw error;
  }
};

// Function to delete (disable) a service user
export const deleteServiceUser = async (
  ServiceUserId: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.SERVICE_USER.DISABLE_SERVICE_USER,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { service_user_id: ServiceUserId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error disabling service user:", error);
    throw error;
  }
};
